import {ClassificationTypes} from '../CASB.types'

// DLP Config Types
export enum DLPState {
  OFF = 'OFF',
  MONITOR = 'MONITOR',
  BLOCK = 'BLOCK',
}

export interface DlpExceptionFormState {
  state: DLPState
  email: string
}

export interface DLPException {
  state: DLPState
}

export type DLPExceptionRecord = Record<string, DLPException>

export interface DLPExceptionsNode {
  exceptions: DLPExceptionRecord
}

export interface DLPMode extends DLPExceptionsNode {
  state: DLPState
  inheritsFromBase: boolean
}

/** title 1-45 chars, body 1-90 chars (enforced by API; typed as string here) */
export interface DLPNotificationMessage {
  title: string
  body: string
}

export interface DLPNotificationsUpdateBody {
  enabled: boolean
  /** Required on PUT even when enabled is false (full-replacement semantics) */
  blocked: DLPNotificationMessage
  monitored: DLPNotificationMessage
}

export interface DLPNotificationsInheritBody {
  inheritsFromBase: true
}

export interface DLPNotificationsResponse extends DLPNotificationsUpdateBody {
  inheritsFromBase: boolean
}

/** Resolved DLP config from GET /policies/{policyName}/dlp */
export interface DLPConfigData {
  mode: DLPMode
  notifications: DLPNotificationsResponse
}

export interface GetDLPConfigResponse {
  data: DLPConfigData
}

export interface UpdateDLPNotificationsPayload {
  data: {
    notifications: DLPNotificationsUpdateBody | DLPNotificationsInheritBody
  }
}

export interface UpdateDLPStatePayload {
  state: DLPState
}

export interface UpdateDLPInheritPayload {
  inheritsFromBase: boolean
}

export interface UpdateDLPRestrictionsPayload {
  mode: UpdateDLPStatePayload | UpdateDLPInheritPayload
}

export interface UpdateDLPExceptionsPayload {
  mode: DLPExceptionsNode
}

// DLP Bypass Types
export interface DLPBypassURL {
  name: string
  note: string
  updatedBy: string
  updatedAt: string
}

export interface DLPBypass {
  inheritsFromBase: boolean
  customUrls: DLPBypassURL[]
}

export interface DLPBypassData {
  bypass: DLPBypass
}

export interface GetDLPBypassResponse {
  data: DLPBypassData
}

export interface UpdateDLPBypassCustomUrlsPayload {
  customUrls: DLPBypassURL[]
}

export interface UpdateDLPBypassInheritPayload {
  inheritsFromBase: boolean
}

export interface UpdateDLPBypassPayload {
  data: {
    bypass: UpdateDLPBypassCustomUrlsPayload | UpdateDLPBypassInheritPayload
  }
}

// DLP Dopamine Types
export interface DLPDopamineData {
  dopamine: string
  classifications: ClassificationTypes[]
}

export interface DLPDopamineResponse {
  data: DLPDopamineData
}

// Context state
export interface DLPConfig {
  mode: DLPMode
  bypass: DLPBypass
  notifications: DLPNotificationsResponse
}

export interface DLPBypassFormData {
  domain: string
  note: string
}
